export const SET_CUSTOM_FORMS = 'SET_CUSTOM_FORMS';
export const SET_CUSTOM_FORM = 'SET_CUSTOM_FORM';
export const UPDATE_CUSTOM_FORM_BUTTON = 'UPDATE_CUSTOM_FORM_BUTTON';
export const ADD_NEW_FORM_OPTION_IN_FORM_FIELD = 'ADD_NEW_FORM_OPTION_IN_FORM_FIELD';
export const REMOVE_FORM_OPTION_IN_FORM_FIELD = 'REMOVE_FORM_OPTION_IN_FORM_FIELD';
export const ADD_NEW_FORM_FIELD_IN_CUSTOM_FORM = 'ADD_NEW_FORM_FIELD_IN_CUSTOM_FORM';
export const REPLACE_FORM_FIELD_IN_CUSTOM_FORM = 'REPLACE_FORM_FIELD_IN_CUSTOM_FORM';
export const DUPLICATE_FORM_FIELD_IN_CUSTOM_FORM = 'DUPLICATE_FORM_FIELD_IN_CUSTOM_FORM';
export const REMOVE_FORM_FIELD_IN_CUSTOM_FORM = 'REMOVE_FORM_FIELD_IN_CUSTOM_FORM';
export const PERIODICITY_SETTINGS_IN_CUSTOM_FORM = 'PERIODICITY_SETTINGS_IN_CUSTOM_FORM';
export const FAMILY_TYPE_SETTINGS_IN_CUSTOM_FORM = 'FAMILY_TYPE_SETTINGS_IN_CUSTOM_FORM';
export const RESET_CUSTOM_FORM = 'RESET_CUSTOM_FORM';
export const TOGGLE_DRAGGABLE_STATE = 'TOGGLE_DRAGGABLE_STATE';


// WEBPACK FOOTER //
// ./src/store/modules/custom-forms/mutations.js